module.exports = __webpack_public_path__ + "img/logo.454bac6d.png";